import React, { Component } from "react";
import { Link } from "react-router";

const GRASS_STYLE = {
  alignItems: "center",
  background: "no-repeat center",
  backgroundColor: "rgb(85,85,85)",
  backgroundImage: "url(/i/grass.jpg)",
  backgroundPosition: "20% center",
  backgroundSize: "cover",
  color: "white",
  display: "flex",
  fontFamily: '"league-gothic",sans-serif',
  fontSize: 110,
  height: 110,
  justifyContent: "center",
  margin: "50px auto 0",
  textShadow: "0px 0px 5px #000",
  width: 930,
};

const FIRST_LETTER_PROPS = {
  style: {
    borderRight: "20px solid white",
    borderLeft: "20px solid white",
    textAlign: "center",
    width: 110,
  },
};
const LETTER_PROPS = {
  style: {
    borderRight: "20px solid white",
    textAlign: "center",
    width: 110,
  },
};

class GrassPage extends Component {
  render() {
    return (
      <div>
        <Link to="/" style={{ textDecoration: "none" }}>
          <div style={GRASS_STYLE}>
            <div {...FIRST_LETTER_PROPS}>S</div>
            <div {...LETTER_PROPS}>Q</div>
            <div {...LETTER_PROPS}>U</div>
            <div {...LETTER_PROPS}>A</div>
            <div {...LETTER_PROPS}>R</div>
            <div {...LETTER_PROPS}>E</div>
            <div {...LETTER_PROPS}>S</div>
          </div>
        </Link>
        <div>{this.props.children}</div>
      </div>
    );
  }
}
export default GrassPage;



// WEBPACK FOOTER //
// ./src/GrassPage.js